import { render, staticRenderFns } from "./IntegrationOffice.vue?vue&type=template&id=b2610be2&"
import script from "./IntegrationOffice.js?vue&type=script&lang=js&"
export * from "./IntegrationOffice.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports